// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleListHeader.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function () {
  var React = require('react');
  var RoleListSearchBox = require('./Izenda.RoleListSearchBox');
  var action = require('./Izenda.RoleListHeaderAction');

  var AuthorizationValidator = require('share/components/hoc/Izenda.AuthorizationValidator');
  var AuthorizationConstants = require('logic/data/Izenda.AuthorizationConstants');

  var AddRole = AuthorizationValidator()(function (props) {
    var localizer = require('share/localization/Izenda.Localizer');
    return (
      <a
        className="overflow-text izenda-AddTenantLink"
        onClick={props.onClick}
        title={localizer.getText('ROLE_SETUP_ROLE_LIST_HEADER_ADD_ROLE')}>
        <span className="icon-plus" />
         {localizer.getText('ROLE_SETUP_ROLE_LIST_HEADER_ADD_ROLE')}
      </a>
    );
  });

  /**
   * Role List Header
   * @param {object} props The component's props that must have 'store' property
   */
  var RoleListHeader = function (props) {
    return (
      <div className="header-panel">
        <AddRole
          onClick={props.addRole}
          keys={[AuthorizationConstants.PERMISSION_KEY.RoleSetupActionsCreate]} />
        <div className="search-box">
          <RoleListSearchBox {...props} />
        </div>
        <hr />
      </div>
    );
  };

  RoleListHeader.propTypes = {
    store: React.PropTypes.object.isRequired
  };

  module.exports = action(RoleListHeader);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/MiddlePanel/Izenda.RoleListHeader.jsx